<div class='ReferralPartnerControl' *ngIf='canAssign'>
  <app-select
    (selection)='onPartnerSelect($event)'
    [defaultValue]='column.referral_partner_id || null'
    [items]='getItems()'
    [label]="'Select referral'"></app-select>
</div>
